import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalEquipmentStyleEditComponent} from './modal-equipment-style-edit.component';
import {FieldModule} from "../../inputs/field/field.module";
import {ButtonModule} from "../../buttons/button/button.module";
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    ModalEquipmentStyleEditComponent
  ],
  exports: [
    ModalEquipmentStyleEditComponent
  ],
  imports: [
    FieldModule,
    CommonModule,
    ButtonModule,
    ReactiveFormsModule
  ]
})
export class ModalEquipmentStyleEditModule {
}
